/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useRef, useState } from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import "intl-tel-input/build/css/intlTelInput.css";
import intlTelInput from "intl-tel-input";
import { GetService, PostService } from "../../../Services/ConstantService";
import { API_URL } from "../../../Services/ApiService";
import { toastEmmit } from "../../../Helper/Toastr";
import { BounceLoader } from "react-spinners";
import PhoneInput from "react-phone-input-2";

export default function ShippingDetails() {

  const [CountryList,setCountryList] = useState([])
  const [StateList,setStateList] = useState([])
  const [loading,setloading] = useState(false)
  const [phoneNumber, setPhoneNumber] = useState("");

  useEffect(()=>{
    GetShippingDetails()
    GetCountryList()
  },[])

  const GetShippingDetails=()=>{
    setloading(true)
    GetService(API_URL.GET_SHIPPING_DETAILS).then((res)=>{
      console.log(res) 
      if(res?.data?.status && res?.data?.data.length){ 
        const data = res?.data?.data[0]
        GetStateList(data?.country)
        formik.setValues({
          first_name: data.first_name,
          last_name: data.last_name,
          email: data.email,
          contact_no: data.contact_no,
          country: data.country,
          state: data.state,
          city: data.city,
          zip_code: data.zip_code,
          address: data.address,
        });
        setPhoneNumber(data?.contact_no)
      }
      setloading(false)
    })
  }


  const validationSchema = Yup.object().shape({
    first_name: Yup.string().required("First Name is required"),
    last_name: Yup.string().required("Last Name is required"),
    email: Yup.string().email("Invalid email").required("Email is required"),
    contact_no: Yup.string().required("Contact No is required"),
    country: Yup.string().required("Country is required"),
    // state: Yup.string().required("State is required"),
    city: Yup.string().required("Town/City is required"),
    zip_code: Yup.string().required("Zip/Postal code is required"),
    address: Yup.string().required("Address is required"),
  });

  const formik = useFormik({
    initialValues: {
      first_name: "",
      last_name: "",
      email: "",
      contact_no: "",
      country: "",
      state: "",
      city: "",
      zip_code: "",
      address: "",
    },
    validationSchema: validationSchema,
    onSubmit: (values) => {
      // Handle form submission logic here
      console.log(values);

      PostService(API_URL.UPDATE_SHIPPING_DETAILS, values).then(
        (res) => {
          console.log(res);
          if (res?.data?.status ) {
            toastEmmit("success", res?.data?.message);  
            // formik.resetForm() 
          }else( toastEmmit("error", res?.data?.message))
        },
        (err) => {
          console.log(err?.response?.data?.message);
          toastEmmit("error", err?.response?.data?.message)
        }
      );
    },
  });

  const GetCountryList = ()=>{
    setloading(true)
    GetService(API_URL.GET_COUNTRY_LIST).then((res)=>{
      console.log(res)
      if(res?.data?.status){
        setCountryList(res?.data?.data)
        setloading(false)
      }
    })
  }

  const GetStateList = (cid)=>{
    setloading(true)
    GetService(`${API_URL.GET_STATE_LIST}?country_id=${cid}`).then((res)=>{
      console.log(res)
      setloading(false)
      if(res?.data?.status){
        setStateList(res?.data?.data) 
      }
    })
  } 

  useEffect(() => {
    // console.log(phoneNumber);
    formik.setFieldValue("contact_no", phoneNumber);
  }, [phoneNumber]);
  

  const handleChange = (value) => {
    formik.setFieldValue("country", value);
    formik.setFieldTouched("country", true);
  };

  // const phoneInputRef = useRef(null);
  // const [selectedCountryCode, setselectedCountryCode] = useState("");

  // useEffect(() => {
  //   const input = phoneInputRef.current;

  //   if (input) {
  //     console.log(input);
  //     const iti = intlTelInput(input, {
  //       separateDialCode: true,
  //       preferredCountries: ["us", "gb"],
  //       // ... other options
  //     });

  //     input.addEventListener("countrychange", function () {
  //       const selectedCountryData = iti.getSelectedCountryData();
  //       setselectedCountryCode(selectedCountryData);
  //     });

  //     const defaultCountry = "us"; // UpdatedData?.country;
  //     if (defaultCountry) {
  //       // Add a check for the existence of UpdatedData?.country
  //       iti.setCountry(defaultCountry);
  //     }

  //     return () => {
  //       if (iti) {
  //         iti.destroy();
  //       }
  //     };
  //   }
  // }, [phoneInputRef.current]);

  return (
    <>
      <div
        className="tab-pane fade active show"
        id="nav-heels"
        role="tabpanel"
        aria-labelledby="nav-heels-tab"
        tabIndex={0}
      >
        <div className="tp-best-product-4__item-box">
          <div className="row">
            <div className="col-xl-12 col-lg-12 col-md-6">
              <div className="heading">
                <p>Shipping Details</p>
              </div>
            </div>
            <form onSubmit={formik.handleSubmit}>
              <div className=" row input">
                <div className="col-xl-6 col-lg-6 col-md-6">
                  <div className="tp-contact-4__input-box mb-20">
                    <label htmlFor="first_name">First Name</label>
                    <input
                      type="text"
                      id="first_name"
                      name="first_name"
                      placeholder="Your First Name"
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      value={formik.values.first_name}
                    />
                    {formik.touched.first_name && formik.errors.first_name && (
                      <div className="error">{formik.errors.first_name}</div>
                    )}
                  </div>
                  <div className="tp-contact-4__input-box mb-20">
                    <label htmlFor="email">Email</label>
                    <input
                      type="text"
                      id="email"
                      name="email"
                      placeholder="Your Email"
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      value={formik.values.email}
                    />
                    {formik.touched.email && formik.errors.email && (
                      <div className="error">{formik.errors.email}</div>
                    )}
                  </div>
                </div>
                <div className="col-xl-6 col-lg-6 col-md-6">
                  <div className="tp-contact-4__input-box mb-20">
                    <label htmlFor="last_name">Last Name</label>
                    <input
                      type="text"
                      id="last_name"
                      name="last_name"
                      placeholder="Your Last Name"
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      value={formik.values.last_name}
                    />
                    {formik.touched.last_name && formik.errors.last_name && (
                      <div className="error">{formik.errors.last_name}</div>
                    )}
                  </div>
                  <div className="tp-contact-4__input-box mb-20 height-4">
                    <label htmlFor="contact_no">Contact No</label>
                    <PhoneInput
                        country={"us"}
                        value={phoneNumber} 
                        onChange={(e) => {
                          const formattedNumber = `+${e.replace(/\D/g, "")}`;
                          setPhoneNumber(formattedNumber); 
                        }}
                      />
                    {/* <input
                      ref={phoneInputRef}
                      type="tel"
                      id="contact_no"
                      name="contact_no"
                      placeholder="Contact No"
                      style={{ paddingLeft: 82 }}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      value={formik.values.contact_no}
                    /> */}
                    {formik.touched.contact_no && formik.errors.contact_no && (
                      <div className="error">{formik.errors.contact_no}</div>
                    )}
                  </div>
                </div>
                <div className="col-xl-6 col-lg-6 col-md-6">
                  <div className="row">
                    <div className="tp-contact-4__input-box mb-20">
                      <label htmlFor="country">Country</label>
                      <select
                        id="country"
                        name="country"
                        className="nice-select selectsection form-select"
                        onChange={(e)=>{formik.handleChange(e);GetStateList(e.target.value);formik.setFieldValue('state', '') }}
                        onBlur={formik.handleBlur}
                        value={formik.values.country}
                      >
                        <option className="selectoptions" value="" selected hidden>
                          Select
                        </option>
                        {CountryList && CountryList.map((country) => (
                          <option
                            className="selectoptions"
                            value={country.country_id}
                          >
                            {country.country_name}
                          </option>
                        ))}
                      </select>
                      {formik.touched.country && formik.errors.country && (
                        <div className="error">{formik.errors.country}</div>
                      )}
                    </div>
                  </div>

                  <div className="row">
                    <div className="tp-contact-4__input-box mb-20  ">
                      <label htmlFor="state">State</label>
                      <select
                        id="state"
                        name="state"
                        className="nice-select selectsection form-select"
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.state}
                      >  
                        <option className="selectoptions" value="" selected hidden>
                          Select
                        </option>
                        {StateList.length<1 && <option className="selectoptions" disabled>No Data Found</option>}
                        {StateList.length > 0 && StateList.map((state) => (
                          <option
                            className="selectoptions"
                            value={state.state_id}
                          >
                            {state.state_name}
                          </option>
                        ))}
                      </select>
                      {/* {formik.touched.state && formik.errors.state && (
                        <div className="error">{formik.errors.state}</div>
                      )} */}
                    </div>
                  </div>

                  <div className="row">
                    <div className="tp-contact-4__input-box mb-20  ">
                      <label htmlFor="zip_code">Zip/Postal code</label>
                      <input
                        type="text"
                        id="zip_code"
                        name="zip_code"
                        placeholder="zipcode"
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.zip_code}
                      />
                      {formik.touched.zip_code && formik.errors.zip_code && (
                        <div className="error">{formik.errors.zip_code}</div>
                      )}
                    </div>
                  </div>
                </div>

                <div className="col-xl-6 col-lg-6 col-md-6">
                  <div className="row">
                    <div className="tp-contact-4__input-box mb-20 ">
                      <label htmlFor="city">Town/City</label> 
                      <input
                        type="text"
                        id="city"
                        name="city"
                        placeholder="City"
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.city}
                      />
                      {formik.touched.city && formik.errors.city && (
                        <div className="error">{formik.errors.city}</div>
                      )} 
                    </div>
                  </div>
                  <div className="row">
                    <div className="tp-contact-4__input-box mb-20">
                      <label htmlFor="address">Address</label>
                      <input
                        type="text"
                        id="address"
                        name="address"
                        placeholder="Address"
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.address}
                      />
                      {formik.touched.address && formik.errors.address && (
                        <div className="error">{formik.errors.address}</div>
                      )}
                    </div>
                  </div>
                </div>

                <div className="tp-contact-4__input-box mb-30 mt-30">
                  <button type="submit" className="tp-btn-lg large head">
                    Save
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>

      {loading ? (
          <div className="LoaderSpinner">
            <BounceLoader
              color={"#607fe6"}
              loading={loading}
              speedMultiplier={2}
              size={50}
            />
            <div className="fw-semibold">Loading... Please wait.</div>
          </div>
        ) : (
          ""
        )}
    </>
  );
}
